import React from 'react'
import Icon from '../misc/Icons'
 
class EditorToolbarButton extends React.Component{

	render(){
		const {onClickFunction, hide, hasToggleState, isLocked, show, iconName, name, tooltip, label, freeLimitDisabled}=this.props
		
		return(
			<button data-tooltip={tooltip && !isLocked && !freeLimitDisabled ? tooltip : null} 
				className={'btn btn--mid btn--white itemEditor-toolbar-btn' 
				+ (name ? ` itemEditor-toolbar-btn--${name}` : '') 
				+ (tooltip && !freeLimitDisabled ? ' tooltip tooltip--label' : '')
				+ (hasToggleState === 'active' ? ' itemEditor-toolbar-btn--active' : '')
				+ (hasToggleState === 'inactive' ? ' itemEditor-toolbar-btn--inactive' : '')							
				+ (hide ? ' itemEditor-toolbar-btn--hidden' : ' ')							
				+ (freeLimitDisabled ? ' itemEditor-toolbar-btn--freeLimitDisabled' : ' ')
				+ (show ? ' itemEditor-toolbar-btn--show' : ' ')
				+ (isLocked ? ' itemEditor-toolbar-btn--isLocked' : ' ')
				+ (!hasToggleState ? ' itemEditor-toolbar-btn--default' : '')}
				onClick={onClickFunction}
				disabled={freeLimitDisabled || isLocked}
			>
	    		{iconName && 
	    			<Icon name={iconName} />
	    		}
	    		{label && 
	    			<span>{label}</span>
	    		}
	    	</button>
		)
	}
}


class EditorToolbarButtonSet extends React.Component{

	render(){
		const {setType, childrenDisabled, disabledTooltip}=this.props
		
		return(
			<div data-tooltip={disabledTooltip && childrenDisabled ? disabledTooltip : null} 
				className={'itemEditor-toolbar-buttonSet' + 
				(setType ? ` itemEditor-toolbar-buttonSet--${setType}` : '') + 
				(childrenDisabled && disabledTooltip ? ' tooltip tooltip--label' : '')}
			>
	    		{this.props.children}
	    	</div>
		)
	}
}


class EditorToolbar extends React.PureComponent{

	render(){

		const {activeQuestionIsSurvey, itemIsLockedByAnotherUser, questionTemplate, isSet, hasImage}=this.props

		
		return(
			<div className={'itemEditor-toolbar' + (isSet ? ' itemEditor-toolbar--set' : ' itemEditor-toolbar--question') + (hasImage ? ' itemEditor-toolbar--image' : ' ')}>
				
				<EditorToolbarButtonSet 
					disabledTooltip='Layout Templates only available with Plickers Pro'
					setType='layout'					
				>

		

					<EditorToolbarButton 
						iconName={hasImage ? 'layout-standard--image' :  'layout-standard--text'}
						hasToggleState={questionTemplate==='standard' ? 'active' : 'inactive'}
						onClickFunction={() =>{this.props.handleChangeTemplate('standard')}}
						tooltip='Standard Layout'						
						isLocked={itemIsLockedByAnotherUser}
					/>
					<EditorToolbarButton 
						iconName={hasImage ? 'layout-center--image' :  'layout-center--text'}
						hasToggleState={questionTemplate==='center' ? 'active' : 'inactive'}
						onClickFunction={() =>{this.props.handleChangeTemplate('center')}}
						tooltip='Center Layout'						
						isLocked={itemIsLockedByAnotherUser}
					/>
					
					{hasImage &&
					<EditorToolbarButton 						
						iconName={hasImage ? 'layout-right--image' :  'layout-right--text'}
						hasToggleState={questionTemplate==='right' ? 'active' : 'inactive'}
						onClickFunction={() =>{this.props.handleChangeTemplate('right')}}
						tooltip={'Right Layout' + (hasImage ? '' : ' (Image Only)')}						
						isLocked={itemIsLockedByAnotherUser}
					/>
					}								

				</EditorToolbarButtonSet>

				<EditorToolbarButtonSet setType='slideType'>
					<EditorToolbarButton 
						label='Graded' 
						hasToggleState={!activeQuestionIsSurvey ? 'active' : 'inactive'}
						onClickFunction={() =>{this.props.setToGraded()}}
						tooltip='Use Graded if the question has a correct answer, for example formative assessments or tests.'
						isLocked={itemIsLockedByAnotherUser}
					/>
					<EditorToolbarButton 
						label='Survey' 
						hasToggleState={activeQuestionIsSurvey ? 'active' : 'inactive'}
						onClickFunction={() =>{this.props.setToSurvey()}}
						tooltip='Use Survey if there is no right or wrong answer, &nbsp;&nbsp; for example student feedback or discussion topics.'
						isLocked={itemIsLockedByAnotherUser}
					/>
					
				</EditorToolbarButtonSet>
				
				<EditorToolbarButtonSet setType='addChoice'>
					<EditorToolbarButton 
						label='Add Choice'
						hide={!this.props.canAddChoice}
						show={this.props.canAddChoice}
						onClickFunction={()=>{this.props.addChoice()}}
						isLocked={itemIsLockedByAnotherUser}
					/> 
				</EditorToolbarButtonSet>


				<EditorToolbarButtonSet setType='slideControl'>		

					
			
					<EditorToolbarButton 
						label='Duplicate'
						onClickFunction={()=>{this.props.duplicateQuestion()}}
						freeLimitDisabled={this.props.maxNumOfQuestionsReached}
						isLocked={itemIsLockedByAnotherUser}
					/>		
					<EditorToolbarButton 
						label='Delete'
						onClickFunction={()=>{this.props.deleteQuestionInSet()}}
						isLocked={itemIsLockedByAnotherUser}
					/>	


				</EditorToolbarButtonSet>				

			</div>
		)
	}
}

export default EditorToolbar
